import {register} from '../modules/eventMap';

const init = (el) => {
    const currencyCode = el.getAttribute('data-kinde-currency-code');
    // Extract the first number (integer or decimal) from the text content
    const match = el.textContent.match(/-?\d+(\.\d+)?/);
    const value = match ? Number(match[0]) : NaN;

    if (isNaN(value)) {
        return;
    }

    const formattedValue = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
        currencyDisplay: 'narrowSymbol',
        trailingZeroDisplay: 'stripIfInteger'
    }).format(value);

    el.textContent = formattedValue;
};

const formatCurrency = () => {
    register('formatCurrency', {init});
};

export {formatCurrency};
